import type {
  TechnologyAccessKeyKind,
  TechnologyAccessKeyStatus,
  TechnologyAiAutonomyLevel,
  TechnologyAiDataClassification,
  TechnologyAiProcessCriticality,
  TechnologyAiRiskClass,
  TechnologyAiSubjectImpact,
  TechnologyAiUsageStatus,
  TechnologyApplicationStatus,
  TechnologyCatalogCategory,
  TechnologyEnvironmentKind,
  TechnologyInfrastructureKind,
  TechnologySecretKind,
} from '../../services/technologyApi';

export const TECHNOLOGY_CATALOG_CATEGORY_OPTIONS: {
  value: TechnologyCatalogCategory;
  label: string;
}[] = [
  { value: 'Software', label: 'Software' },
  { value: 'Database', label: 'Banco de dados' },
  { value: 'Framework', label: 'Framework' },
  { value: 'CloudService', label: 'Serviço cloud' },
  { value: 'OperatingSystem', label: 'Sistema operacional' },
  { value: 'Library', label: 'Biblioteca' },
  { value: 'AiModel', label: 'Modelo de IA' },
  { value: 'ProgrammingLanguage', label: 'Linguagem de Programação' },
  { value: 'Other', label: 'Outro' },
];

export function programmingLanguageLabel(
  catalogItems: readonly { name: string; category?: string | null }[] | null | undefined,
): string {
  return (catalogItems ?? [])
    .filter((item) => item.category === 'ProgrammingLanguage')
    .map((item) => item.name)
    .filter((name) => name.trim().length > 0)
    .join(', ');
}

export const TECHNOLOGY_INFRASTRUCTURE_KIND_OPTIONS: {
  value: TechnologyInfrastructureKind;
  label: string;
}[] = [
  { value: 'Server', label: 'Servidor / VPS' },
  { value: 'Cloud', label: 'Cloud' },
  { value: 'Database', label: 'Banco de dados' },
  { value: 'Storage', label: 'Storage' },
  { value: 'Cdn', label: 'CDN' },
  { value: 'LoadBalancer', label: 'Load balancer' },
  { value: 'Network', label: 'Rede' },
  { value: 'Other', label: 'Outro' },
];

export const TECHNOLOGY_ACCESS_KEY_KIND_OPTIONS: {
  value: TechnologyAccessKeyKind;
  label: string;
}[] = [
  { value: 'Ssh', label: 'SSH' },
  { value: 'Api', label: 'API' },
  { value: 'MachineIdentity', label: 'Identidade de máquina' },
  { value: 'Other', label: 'Outro' },
];

export const TECHNOLOGY_ACCESS_KEY_STATUS_OPTIONS: {
  value: TechnologyAccessKeyStatus;
  label: string;
}[] = [
  { value: 'Active', label: 'Ativa' },
  { value: 'PendingRotation', label: 'Pendente de rotação' },
  { value: 'Revoked', label: 'Revogada' },
  { value: 'Expired', label: 'Expirada' },
];

export const TECHNOLOGY_APPLICATION_STATUS_OPTIONS: {
  value: TechnologyApplicationStatus;
  label: string;
}[] = [
  { value: 'Draft', label: 'Rascunho' },
  { value: 'Active', label: 'Ativa' },
  { value: 'Deprecated', label: 'Depreciada' },
  { value: 'Retired', label: 'Descontinuada' },
];

export const TECHNOLOGY_ENVIRONMENT_KIND_OPTIONS: {
  value: TechnologyEnvironmentKind;
  label: string;
}[] = [
  { value: 'Development', label: 'Desenvolvimento' },
  { value: 'Homologation', label: 'Homologação' },
  { value: 'Production', label: 'Produção' },
  { value: 'DisasterRecovery', label: 'Disaster Recovery' },
];

export const TECHNOLOGY_SECRET_KIND_OPTIONS: {
  value: TechnologySecretKind;
  label: string;
}[] = [
  { value: 'Password', label: 'Senha' },
  { value: 'Token', label: 'Token' },
  { value: 'ApiKey', label: 'API Key' },
  { value: 'OAuth', label: 'OAuth' },
  { value: 'Jwt', label: 'JWT' },
  { value: 'License', label: 'Licença' },
  { value: 'Other', label: 'Outro' },
];

export const TECHNOLOGY_RELEASE_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'Draft', label: 'Rascunho' },
  { value: 'Planned', label: 'Planejada' },
  { value: 'Building', label: 'Em build' },
  { value: 'Ready', label: 'Pronta' },
  { value: 'Released', label: 'Liberada' },
  { value: 'Cancelled', label: 'Cancelada' },
];

export const TECHNOLOGY_DEPLOYMENT_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'Scheduled', label: 'Agendada' },
  { value: 'InProgress', label: 'Em andamento' },
  { value: 'Succeeded', label: 'Concluída' },
  { value: 'Failed', label: 'Falhou' },
  { value: 'Cancelled', label: 'Cancelada' },
  { value: 'RolledBack', label: 'Revertida' },
];

export const TECHNOLOGY_AI_DATA_OPTIONS: {
  value: TechnologyAiDataClassification;
  label: string;
}[] = [
  { value: 'None', label: 'Nenhum' },
  { value: 'Public', label: 'Público' },
  { value: 'Personal', label: 'Pessoal' },
  { value: 'Sensitive', label: 'Sensível' },
];

export const TECHNOLOGY_AI_AUTONOMY_OPTIONS: {
  value: TechnologyAiAutonomyLevel;
  label: string;
}[] = [
  { value: 'Assistive', label: 'Assistivo' },
  { value: 'Recommendation', label: 'Recomendação' },
  { value: 'DecisionSupport', label: 'Apoio à decisão' },
  { value: 'AutomatedWithReview', label: 'Decisão automatizada com revisão' },
  { value: 'AutomatedWithoutReview', label: 'Decisão automatizada sem revisão' },
];

export const TECHNOLOGY_AI_IMPACT_OPTIONS: {
  value: TechnologyAiSubjectImpact;
  label: string;
}[] = [
  { value: 'Low', label: 'Baixo' },
  { value: 'Medium', label: 'Médio' },
  { value: 'High', label: 'Alto' },
  { value: 'Critical', label: 'Crítico' },
];

export const TECHNOLOGY_AI_CRITICALITY_OPTIONS: {
  value: TechnologyAiProcessCriticality;
  label: string;
}[] = [
  { value: 'Low', label: 'Baixa' },
  { value: 'Medium', label: 'Média' },
  { value: 'High', label: 'Alta' },
  { value: 'Critical', label: 'Crítica' },
];

export const TECHNOLOGY_AI_RISK_CLASS_OPTIONS: {
  value: TechnologyAiRiskClass;
  label: string;
}[] = [
  { value: 'Minimal', label: 'Mínimo' },
  { value: 'Limited', label: 'Limitado' },
  { value: 'High', label: 'Alto' },
  { value: 'Unacceptable', label: 'Inaceitável' },
];

export const TECHNOLOGY_AI_USAGE_STATUS_OPTIONS: {
  value: TechnologyAiUsageStatus;
  label: string;
}[] = [
  { value: 'Active', label: 'Ativo' },
  { value: 'Retired', label: 'Descontinuado' },
];

export const TECHNOLOGY_AI_RISK_MATRIX_RULES: string[] = [
  'Inaceitável: decisão automatizada sem revisão humana e (dado sensível ou impacto crítico aos titulares).',
  'Alto: dado sensível, ou qualquer decisão automatizada, ou impacto alto ou crítico, ou processo crítico.',
  'Limitado: dado pessoal, ou apoio à decisão, ou impacto médio, ou processo de criticidade alta.',
  'Mínimo: demais combinações, com autonomia até recomendação, impacto baixo e processo de criticidade baixa ou média.',
];

export const TECHNOLOGY_INTEGRATION_KIND_OPTIONS: { value: string; label: string }[] = [
  { value: 'Crm', label: 'CRM' },
  { value: 'Ai', label: 'IA' },
  { value: 'Cloud', label: 'Cloud' },
  { value: 'Support', label: 'Atendimento' },
  { value: 'Payment', label: 'Pagamento' },
  { value: 'Other', label: 'Outro' },
];

export const TECHNOLOGY_INTEGRATION_AUTH_OPTIONS: { value: string; label: string }[] = [
  { value: 'None', label: 'Nenhuma' },
  { value: 'ApiKey', label: 'API key' },
  { value: 'OAuth', label: 'OAuth' },
  { value: 'Basic', label: 'Básica' },
  { value: 'Certificate', label: 'Certificado' },
  { value: 'SshKey', label: 'Chave SSH' },
];

export const TECHNOLOGY_INTEGRATION_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'Active', label: 'Ativa' },
  { value: 'Degraded', label: 'Degradada' },
  { value: 'Inactive', label: 'Inativa' },
];

export const TECHNOLOGY_CERTIFICATE_KIND_OPTIONS: { value: string; label: string }[] = [
  { value: 'Ssl', label: 'SSL/TLS' },
  { value: 'A1', label: 'A1' },
  { value: 'A3', label: 'A3' },
  { value: 'ApiClient', label: 'API / cliente' },
  { value: 'Other', label: 'Outro' },
];

export const TECHNOLOGY_CERTIFICATE_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'Active', label: 'Ativo' },
  { value: 'Revoked', label: 'Revogado' },
];

export const TECHNOLOGY_CERTIFICATE_EXPIRATION_OPTIONS: { value: string; label: string }[] = [
  { value: 'Valid', label: 'Válido' },
  { value: 'Expiring', label: 'Vence em 30 dias' },
  { value: 'Expired', label: 'Vencido' },
  { value: 'Revoked', label: 'Revogado' },
];

export const TECHNOLOGY_RELEASE_ITEM_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'WorkItem', label: 'Work item' },
  { value: 'PullRequest', label: 'Pull request' },
  { value: 'Note', label: 'Nota' },
];

export function technologyOptionLabel(
  options: readonly { value: string; label: string }[],
  value: string,
): string {
  return options.find((option) => option.value === value)?.label ?? value;
}
